import React from "react";
import { Button, CardActions, CardText } from "react-md";
import RegistrationCard from "../../RegistrationCard";

const MinorsInParty = ({ onSubmit }) => (
  <RegistrationCard
    title="Are there any minors shooting with you today?"
    subtitle="For shooting range purposes, a minor is anyone between the ages of 12 and 21"
  >
    <CardText>
      <p>Please note the following:</p>
      <ul>
        <li>Shooters under the age of 12 are not permitted.</li>
        <li>Minors must be accompanied by their legal guardian.</li>
        <li>Notes from legal guardians are not sufficient.</li>
        <li>Additional adults in your group must register separately.</li>
      </ul>
    </CardText>
    <CardActions>
      <Button
        raised
        label="Yes"
        primary
        className="md-cell--left"
        onClick={() => onSubmit({ nextStep: "minors/0/contact-info" })}
      />
      <Button
        raised
        label="No"
        secondary
        className="md-cell--right"
        onClick={() => onSubmit({ nextStep: "range-rules" })}
      />
    </CardActions>
  </RegistrationCard>
);

MinorsInParty.propTypes = {};
MinorsInParty.defaultProps = {};

export default MinorsInParty;



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorsInParty/MinorsInParty.jsx